import React, { useState, useRef, useMemo, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import ModalDrawer from '../ModalDrawer';
import Button, { ButtonSizes, ButtonStyles } from '../../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../../Icons/Icon';
import { TRANSLATIONS } from '../../../../translations';
import { ModalOrderCard } from './ModalOrderCard';
import Dialog, { DialogAlignments, DialogTypes } from '../../Dialog/Dialog';
import { useMatchesMinWidth } from '../../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../../constants';
import { Loader } from '../../common';

const CompleteRefundConfirmed = ({
  goBack,
  isOpen,
  setIsOpen,
  modalTitle,
  order,
  onSubmit,
  isOnlyChoice,
  isLoading,
}) => {
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_LANDSCAPE
  );

  return (
    <ModalDrawer
      {...(!isOnlyChoice && goBack ? { goBack: () => goBack() } : {})}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDeviceSmallerThanTablet={isDeviceSmallerThanMblLandscape}
      modalCustomWidth={640}
      title={modalTitle}
      content={
        <div className="pl-m pr-m pt-xl pb-xl w-100% d-flex flex-column gap-m">
          {isLoading ? (
            <div className="d-flex justify-center text-center">
              <Loader loading={isLoading} />
            </div>
          ) : (
            <>
              <Dialog
                align={DialogAlignments.row}
                type={DialogTypes.feature}
                content={TRANSLATIONS.IF_CANCELLED_POLICIES_WILL_BE_APPLIED}
                icon={
                  <BetaIcon
                    name={'info'}
                    color={IconColors.regular}
                    size={IconSizes[24]}
                  />
                }
              />
              <div className="d-flex flex-column gap-xs">
                <div
                  className="typography__p3 typography__neutral text-left"
                  dangerouslySetInnerHTML={{
                    __html:
                      TRANSLATIONS.THE_AMOUNT_WILL_BE_AVAILABLE_IN_5_10_DAYS,
                  }}
                />
                <ModalOrderCard
                  order={order}
                  toBeRefunded={true}
                  showPolicy={true}
                />
              </div>
            </>
          )}
        </div>
      }
      footer={
        isLoading ? null : (
          <div className="d-flex gap-m pb-m pl-xl pr-xl">
            <Button
              disabled={isLoading}
              classNames={'flex-1 pr-m pl-m'}
              size={ButtonSizes.s}
              style={ButtonStyles.empty}
              label={TRANSLATIONS.CANCEL}
              onClick={() => setIsOpen(false)}
            />
            <Button
              disabled={isLoading}
              classNames={'flex-1 pr-m pl-m'}
              size={ButtonSizes.s}
              style={ButtonStyles.secondary}
              label={TRANSLATIONS.CONFIRM}
              onClick={() => onSubmit()}
            />
          </div>
        )
      }
    />
  );
};

CompleteRefundConfirmed.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
};

export { CompleteRefundConfirmed };
